<div class="modal-header">
    <h5 class="modal-title"> تفعيل الحساب</h5>
    <button type="button" class="close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="loading-indicator" *ngIf="global.spinner">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
</div>
<div class="container">
    <form [formGroup]="ActiveForm" autocomplete="off" (ngSubmit)="ActiveUser()">

    <div class="row">
        
        <div class="col-lg-12">
                <mat-form-field appearance="fill">
                    <mat-label>رمز التفعيل </mat-label>
                    <input matInput formControlName="RondumNumber" [ngClass]="{ 'is-invalid': submitted && f.RondumNumber.errors }" >
                    <mat-error *ngIf="submitted && f.RondumNumber.errors" class="invalid-feedback">
                      <span *ngIf="f.RondumNumber.errors.required">يجب تسجيل قيمه</span>
                      <span *ngIf="f.RondumNumber.errors.maxlength"> خطأادخل أربع أرقام</span>
                      <span *ngIf="f.RondumNumber.errors.minlength"> خطأادخل أربع أرقام</span>

                    </mat-error>
                  </mat-form-field>
        </div>
        <div class="col-lg-12">
            <button id="btnAdd" style="width: 25%;height: 40px;background-color:#00839b;color:#fff;border:none;margin-top: 50px;margin:auto;display:table;margin-bottom:20px" 
             class="btn btn-primary" type="submit" [disabled]="f.invalid ">اضافه</button>

        </div>
    </div>
    </form>
</div>